package top.wcpe.allincore.ui.runtime.ir.api

import top.wcpe.allincore.ui.runtime.reactive.Signal
import kotlin.jvm.JvmField

/** v4 client.options DSL 作用域。 */
interface OptionsApi {
    fun entries(): Map<String, Signal<Any?>>
    fun get(key: String?): Any?
    fun set(key: String, value: Any?)
    fun save()
    fun availableLanguages(): List<Map<String, Any>>
    fun availableLanguagesForUi(): List<Map<String, Any>>
    fun availableSoundDevices(): List<String>
    fun reloadResourcePacks()
    fun playUiSound()

    /**
     * 播放指定资源包声音事件 ID 的点击音；默认委托 [playUiSound]（无参版），
     * 平台实现可覆盖以播放自定义声音事件。
     */
    fun playUiSound(soundId: String) {
        playUiSound()
    }

    /** 播放分级交互 hover 音；默认委托 [playUiSound]。 */
    fun playUiHoverSound() {
        playUiSound()
    }

    /** 播放指定资源包声音事件 ID 的 hover 音；默认委托 [playUiSound]。 */
    fun playUiHoverSound(soundId: String) {
        playUiSound(soundId)
    }

    companion object {
        @JvmField val NOOP: OptionsApi = object : OptionsApi {
            override fun entries(): Map<String, Signal<Any?>> = emptyMap()
            override fun get(key: String?): Any? = null
            override fun set(key: String, value: Any?) {}
            override fun save() {}
            override fun availableLanguages(): List<Map<String, Any>> = emptyList()
            override fun availableLanguagesForUi(): List<Map<String, Any>> = emptyList()
            override fun availableSoundDevices(): List<String> = emptyList()
            override fun reloadResourcePacks() {}
            override fun playUiSound() {}
        }
    }
}
